import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadProjectAndSubProjectBulletins } from 'scenes/BulletinBoard/store/thunks/loadProjectAndSubProjectBulletins';
import {
  selectCurrentUserBusinessPermissions,
  selectIsAdminInSelectedProject,
} from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { loadAllCurrentUserPermissions } from 'scenes/Permissions/store/thunks/loadAllCurrentUserPermissions.thunk';
import { setSelectedProjectId } from 'scenes/Project/store/actions/projectActions';
import { setProject } from 'store/actions/setProject';
import { loadApprovalGroupsByProject } from 'store/approvals/thunks/loadApprovalGroupsByProject';
import { loadAllowancesOfCurrentUserEmployers } from 'store/employerAllowances/thunks/loadAllowancesOfCurrentUserEmployers.thunk';
import { clearSelectedRecords } from 'store/records/actions/records.actions';
import {
  setPersonalWorkCalendarMode,
  setSelectionMode,
} from '../actions/demoActions';
import { loadAdminInitialDataInTimeFrame } from './loadAdminInitialDataInTimeFrame';
import { loadInitialCalendarData } from './loadInitialCalendarData.thunk';
import { loadInitialCalendarDataForAdmin } from './loadInitialCalendarDataForAdmin.thunk';
import { loadSubcontractorRecordsData } from './loadSubcontractorRecordsData.thunk';
import { loadSubcontractorEmployeeData } from './loadSubcontractorEmployeeData.thunk';
import { SUBCONTRACTORS_RECORDS_VIEW } from 'scenes/Permissions/constants/permissions';

export const initWorkCalendar = createAsyncThunk(
  'project/initWorkCalendar',
  async ({ projectId, viewMode }, { dispatch, getState }) => {
    const currentUserBusinessPermissions = selectCurrentUserBusinessPermissions(
      getState()
    );

    // IN THE FUTURE CHECK ONLY WITH CURRENT ACTIVE EMPLOYER BUSINESS ID
    const businessPermissionsWithPermissionForSubcontractorRecords =
      Object.values(currentUserBusinessPermissions).find(
        (businessPermissions) =>
          businessPermissions[SUBCONTRACTORS_RECORDS_VIEW]
      );

    dispatch(setProject({ id: projectId }));
    dispatch(setSelectedProjectId(projectId));
    dispatch(clearSelectedRecords());
    if (viewMode === 'invoice') {
      dispatch(setSelectionMode(true));
    } else {
      dispatch(setSelectionMode(false));
    }
    dispatch(loadProjectAndSubProjectBulletins());
    dispatch(setPersonalWorkCalendarMode(false));
    dispatch(loadAllowancesOfCurrentUserEmployers());

    await dispatch(loadAllCurrentUserPermissions());
    dispatch(loadApprovalGroupsByProject(projectId));

    const state = getState();
    const isAdminInSelectedProject = selectIsAdminInSelectedProject(state);

    if (isAdminInSelectedProject) {
      await dispatch(loadAdminInitialDataInTimeFrame());
      dispatch(loadInitialCalendarDataForAdmin());
    } else {
      if (businessPermissionsWithPermissionForSubcontractorRecords) {
        console.log('IS PERMISSION, SEARCH SUBCONTRACTORS');
        await Promise.allSettled([
          dispatch(loadInitialCalendarData()),
          dispatch(loadSubcontractorEmployeeData()),
          dispatch(loadSubcontractorRecordsData()),
        ]);
      } else {
        await dispatch(loadInitialCalendarData());
      }
    }
  }
);
